import { render, staticRenderFns } from "./DialogIdentify.vue?vue&type=template&id=02e65300&scoped=true"
import script from "./DialogIdentify.vue?vue&type=script&lang=ts"
export * from "./DialogIdentify.vue?vue&type=script&lang=ts"
import style0 from "./DialogIdentify.vue?vue&type=style&index=0&id=02e65300&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e65300",
  null
  
)

export default component.exports